import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router} from '@angular/router';
import {GameService} from "../services/game.service";


export const providerGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {

  //only show valid provider pages

  const gameService = inject(GameService);
  const router = inject(Router);

  const requestedProvider = route.params['provider'];

  let providerToNavigate;
  providerToNavigate = gameService.providers.find(p => p.routerLink === requestedProvider) //uses initial value when we refresh the page
  if (providerToNavigate){
    return true;
  }
  router.navigate(['/not-found']);
  return false;


  // return gameService.providers$.pipe(
  //   skipWhile(providers => providers === gameService.defaultProviders), // Wait for API data
  //   first(), // Ensure we only take the first valid value
  //   timeout({ first: 3000 }), // If no API response in 5s, throw an error
  //   catchError(() => of([])), // Handle timeout or network error by returning an empty array
  //   map(providers => {
  //     const providerExists = providers.some(p => p.routerLink === requestedProvider);
  //     return providerExists || router.createUrlTree(['/not-found']);
  //   })
  // );


};
